export const chipSX = {
	display: 'flex',
	alignItems: 'center',
	height: '32px',
	backgroundColor: '#fff',
	border: 'none',
	borderRadius: 1,
	boxShadow: 'none',
	padding: '5px 10px',
	cursor: 'pointer',
	color: 'secondary.main',
	fontSize: '0.875rem',

	'& .MuiChip-avatar': {
		color: 'secondary.main',
	},
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	'& a:visited': {
		color: 'secondary.main',
	},
};

export const lastBreadcrumbSX = {
	...chipSX,
	color: 'grey.500',
	cursor: 'default',
	backgroundColor: '#fff',
	opacity: 0.5,
	boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
};
